import { render, staticRenderFns } from "./CustomerChangeDialog.vue?vue&type=template&id=991a080c&scoped=true"
import script from "./CustomerChangeDialog.vue?vue&type=script&lang=js"
export * from "./CustomerChangeDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerChangeDialog.vue?vue&type=style&index=0&id=991a080c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991a080c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('991a080c')) {
      api.createRecord('991a080c', component.options)
    } else {
      api.reload('991a080c', component.options)
    }
    module.hot.accept("./CustomerChangeDialog.vue?vue&type=template&id=991a080c&scoped=true", function () {
      api.rerender('991a080c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/AdminSummarySubs/CustomerChangeDialog.vue"
export default component.exports